import { render, staticRenderFns } from "./ProductDisplayOrderIframe.vue?vue&type=template&id=0379f638&"
import script from "./ProductDisplayOrderIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDisplayOrderIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports